import { combineReducers } from 'redux';

import sidebar, { UiSidebarState } from './sidebar';
import orgname, { IOrgNameState } from './orgName/reducer';
import imagelist, { ImageComparationType } from './imgComparation';

export interface UiState {
  sidebar: UiSidebarState;
  orgname: IOrgNameState;
  imagelist:ImageComparationType
}

const reducer = combineReducers<UiState>({ sidebar, orgname, imagelist });

export default reducer;
